export default {
  methods: {
    formatPrice: function (price) {
      return typeof price !== "undefined"
        ? price.toLocaleString("en-US", { style: "currency", currency: "USD" })
        : "";
    },
    setError: function (code, message) {
      this.$store.dispatch("configurator/setError", {
        code: code,
        message: message || ""
      });
    }
  }
};
